import { downArrow } from '@/static/assets/giveback_2022';
import { Box, font, preventOneWordInLastLine, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
0%,
100% {
    transform: translateY(0px);
}
70% {
    transform: translateY(-12px);
}
`;

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  color: ${themedColor('night')};
  margin: 0 auto;

  ${MEDIA_QUERIES.mobile`
        padding: 0px 18px;
        height: calc(100vh - 70px);
        letter-spacing: -2px;
        ${font('main', {
          fontSize: '46px',
          lineHeight: '50.5px',
          fontWeight: 800,
        })};
    `}

  ${MEDIA_QUERIES.tablet`
        padding: 0px 36px;
        height: calc(100vh - 70px);
        letter-spacing: -4px;
        ${font('main', {
          fontSize: '78px',
          lineHeight: '93px',
          fontWeight: 800,
        })};
    `}

    ${MEDIA_QUERIES.desktop`
        max-width: 1044px;
        height: calc(100vh - 150px);
        letter-spacing: -4px;
        ${font('main', {
          fontSize: '78px',
          lineHeight: '93px',
          fontWeight: 800,
        })};
    `}


    @media (min-width: 1920px) {
    max-width: 1305px;
    height: calc(100vh - 150px);
    letter-spacing: -4px;
    ${font('main', {
      fontSize: '95px',
      lineHeight: '110px',
      fontWeight: 800,
    })};
  }
`;

const StyledImg = styled.img`
  width: 40px;
  height: 40px;
  margin: 64px auto 0px;
  animation: ${bounce} 1.5s infinite ease-in-out;
`;

const TITLE =
  'In the 2022 Giveback, the Lemonade community gave back $1,873,588 to 59 nonprofits. Let’s break it down:';

const Giveback2022Header: React.FC = () => {
  return (
    <StyledContainer>
      <div
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{ __html: preventOneWordInLastLine(TITLE) }}
      />
      <StyledImg src={downArrow.src} alt="down arrow" />
    </StyledContainer>
  );
};

export default Giveback2022Header;
